import React, { useCallback, useEffect, useState } from 'react';
import { Handle, Position } from '@xyflow/react';
import styled from 'styled-components';
import {
  Avatar,
  Button,
  Heading,
  Tooltip as SuperopsTooltip,
  TextStyle,
  Badge,
  Popover,
  ActionList,
  Banner,
  DisplayText,
  TextField,
  Modal,
  ButtonGroup,
  Page
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import envConfig from '@nile/home/src/Config/env';
import {
  getTranslatedText,
  COLOR_MAP,
  TEXT_LENGTH,
  CustomModal,
  toast,
  RunbookNodeActivatorContent,
  withErrorBoundary
} from '@nile/components';
import { injectIntl, FormattedMessage } from 'react-intl';
import AssociateTasks from '@nile/mangifera/src/Containers/ChatContainers/AssociateTasks';
import TaskFromRevamp from '@nile/components/src/Forms/TaskFromRevamp';
import {
  CREATE_TASK_TEMPLATE,
  UPDATE_TASK_TEMPLATE,
  GET_TASK_TEMPLATE
} from '@nile/graphql';
import { useMutation, useQuery } from '@apollo/client';
import { isEmpty } from 'lodash';

function AssociateTaskModal(props) {
  const { intl, isAutoAction } = props;
  const [selectedList, setSelectedList] = useState([]);
  const [saveAsTemplate, setSaveAsTemplate] = useState(true);

  // Extract formData and actionValueData from props
  const formData = props?.autoActionformData || props?.data?.formData || {};
  const actionValueData =
    props?.autoActionformData?.actionValueData || formData?.actionValueData;

  const initialTaskTemplate =
    formData?.uiData?.taskTemplate || actionValueData?.taskTemplate || {};
  const initialTaskTemplateId =
    initialTaskTemplate?.taskTemplateId || initialTaskTemplate || null;

  const [apiSelectedId, setApiSelectedId] = useState(initialTaskTemplateId);
  const [taskTemplate, setTaskTemplate] = useState(initialTaskTemplate);

  // State for all tasks
  const [allTasks, setAllTasks] = useState([]);

  const parentActionId = formData?.parentActionId;
  const hasActionId = formData?.actionId;

  const [popoverActive, setPopoverActive] = useState(
    Boolean(
      (isAutoAction && !props?.autoActionformData) ||
        (!isAutoAction && !hasActionId)
    )
  );

  const showDeleteButton =
    (isAutoAction && props?.autoActionformData) ||
    (!isAutoAction && hasActionId);

  const [createTaskActive, setCreateTaskActive] = useState(false);

  const templateId = initialTaskTemplateId;

  const { loading, data: taskTemplateData, refetch } = useQuery(
    GET_TASK_TEMPLATE,
    {
      variables: { templateId },
      skip: !templateId
    }
  );

  const togglePopoverActive = useCallback(() => {
    setPopoverActive((active) => !active);
  }, []);

  const toggleCreateTask = () => {
    setCreateTaskActive((active) => !active);
  };
  const saveLoading = false;

  const activator = (
    <RunbookNodeActivatorContent
      nodeType="admin.runbooks.templateactions.associatetask"
      nodeName={taskTemplate?.title || taskTemplate?.name}
      iconName="TaskColoured"
      callBackFunction={() => {
        if (taskTemplate?.taskTemplateId) {
          toggleCreateTask();
        } else {
          togglePopoverActive();
        }
      }}
    />
  );

  const updateTaskList = (selectedListArg) => {
    // const temp = [];
    // selectedListArg.forEach((task) => {
    //   temp.push(task.taskTemplateId);
    // });
    setSelectedList(selectedListArg);
  };

  const onSave = () => {
    selectedList.forEach((template, idx) => {
      let newId = props.id;

      if (props.isAutoAction) {
        // if (idx > 0) {
        newId = props.id + idx;
        // }
      }

      const formDataTemp = {
        name: formData?.name || '',
        id: newId,
        actionType: 'SINGLE',
        actionProcessCategory: props?.isAutoAction ? 'ASYNC' : 'SYNC',
        actionValueType: 'TASK_TEMPLATE',
        actionValueData: {
          nodeId: newId,
          taskTemplate: {
            taskTemplateId: template.taskTemplateId,
            taskTemplateName: template.title
          }
        },
        uiData: {
          taskTemplate: template
        }
      };

      if (hasActionId) {
        formDataTemp.actionId = hasActionId;
      }

      if (parentActionId) {
        formDataTemp.parentActionId = parentActionId;
      }

      if (props.isAutoAction) {
        props.autoActionSave(formDataTemp);
      } else if (idx < 1) {
        setTaskTemplate(template);
        props.modifyNodeData(formDataTemp);
      } else {
        props.handleNodeAddition({
          name: 'Associate Task',
          formData: formDataTemp
        });
      }
    });

    togglePopoverActive();
  };

  const closeBothModal = () => {
    setPopoverActive(false);
    setCreateTaskActive(false);
  };

  useEffect(() => {
    if (apiSelectedId && taskTemplateData?.getTaskTemplate) {
      const foundTemplate = taskTemplateData.getTaskTemplate;
      if (
        !isEmpty(foundTemplate) &&
        foundTemplate.taskTemplateId === apiSelectedId
      ) {
        setTaskTemplate(foundTemplate);
        closeBothModal();
      }
    }
  }, [taskTemplateData, apiSelectedId]);

  const [createTaskTemplateApi] = useMutation(CREATE_TASK_TEMPLATE, {
    onCompleted({ createTaskTemplate }) {
      toggleCreateTask();

      /* Close sheet container once an employee created */
      if (createTaskTemplate) {
        setTaskTemplate(createTaskTemplate);
        toast('success', 'admin.taskTemplates.taskTemplateCreate.success');

        let newId = props.id;
        if (props.isAutoAction) {
          newId = props.id;
        }
        const formData2 = {
          name: formData?.name || '',
          id: newId,
          actionType: 'SINGLE',
          actionProcessCategory: props?.isAutoAction ? 'ASYNC' : 'SYNC',
          actionValueType: 'TASK_TEMPLATE',
          actionValueData: {
            nodeId: newId,
            taskTemplate: {
              taskTemplateId: createTaskTemplate.taskTemplateId,
              taskTemplateName: createTaskTemplate.title
            }
          },
          uiData: {
            taskTemplate: createTaskTemplate
          }
        };

        if (hasActionId) {
          formData2.actionId = hasActionId;
        }
        formData2;
        if (parentActionId) {
          formData2.parentActionId = parentActionId;
        }

        if (props.isAutoAction) {
          props.autoActionSave(formData2);
        } else {
          props.modifyNodeData(formData2);
        }
      }
    }
  });

  // const [updateTaskTemplate] = useMutation(UPDATE_TASK_TEMPLATE, {
  //   onCompleted(res) {
  //     if (res?.updateTaskTemplate) {
  //       // const formData = {
  //       //   name: props.id,
  //       //   id: props.id,
  //       //   actionType: 'SINGLE',
  //       //   actionProcessCategory: 'SYNC',
  //       //   actionValueType: 'TASK_TEMPLATE',
  //       //   actionValueData: {
  //       //     taskTemplate: res?.updateTaskTemplate
  //       //   }
  //       // };
  //       // props.modifyNodeData(formData);
  //       toast('success', 'admin.taslTemplates.taskTemplateUpdate.success');
  //     }
  //   }
  // });

  const addorUpdateTask = (type, task, setSubmitActionLoading) => {
    const {
      name: title,
      description,
      technician,
      techGroup,
      estimatedTime,
      inlineImages,
      dueDate,
      scheduledStartDate
    } = task;

    const techInput = technician && {
      userId: technician.userId,
      email: technician.email
    };
    const groupInput = techGroup && { groupId: techGroup.groupId };

    const requestVariables = {
      variables: {
        title,
        description,
        technician: techInput,
        techGroup: groupInput,
        estimatedTime,
        inlineImages,
        taskTemplateId: taskTemplate?.taskTemplateId,
        dueDate,
        scheduledStartDate,
        shared: saveAsTemplate
      },
      input: {
        title,
        description,
        technician: techInput,
        techGroup: groupInput,
        estimatedTime,
        inlineImages,
        taskTemplateId: taskTemplate?.taskTemplateId,
        dueDate,
        scheduledStartDate,
        shared: saveAsTemplate
      }
    };

    const taskTemplateTemp = {
      ...task,
      taskTemplateId: taskTemplate?.taskTemplateId,
      title: task?.name,
      shared: saveAsTemplate
    };

    setTaskTemplate(taskTemplateTemp);

    if (type === 'update') {
      // update not supported.

      setCreateTaskActive(false);
      // requestVariables.variables.templateId = taskTemplateId;
      // requestVariables.input.templateId = taskTemplateId;
      // updateTaskTemplate(requestVariables);
      // props.modifyNodeData(formData);
      return;
    }

    createTaskTemplateApi(requestVariables)
      .then((response) => {
        // Handle success
      })
      .catch((error) => {
        // Handle error
        setSubmitActionLoading(false);
      });
  };

  const handleNodeDelete = () => {
    if (props.isAutoAction) {
      props.handleAutoActionDelete(props.id);
    } else {
      props.data.handleNodeDelete(props.id, hasActionId);
    }

    closeBothModal();
  };

  return (
    <>
      <Modal
        medium
        activator={activator}
        open={popoverActive}
        onClose={() => {
          handleNodeDelete();
        }}
        showCloseButton={false}
        noScroll
      >
        {!createTaskActive && !taskTemplate?.taskTemplateId && (
          <Page
            title={getTranslatedText(
              intl,
              'ticket.details.tasks.create.associatetasks'
            )}
            contentHeight="110px"
            fullWidth
            disableScroll
            variant="secondary"
            primaryAction={
              <ButtonGroup spacing="loose">
                <Button
                  plainSecondary
                  onClick={() => {
                    handleNodeDelete();
                  }}
                >
                  <FormattedMessage id="app.close.btn" />
                </Button>
                <Button
                  primary={false}
                  icon={<SVGIcon name="Add" />}
                  onClick={() => {
                    togglePopoverActive();
                    toggleCreateTask();
                  }}
                  loading={saveLoading}
                >
                  {/* <FormattedMessage id="admin.runbooks.create" /> */}
                  Create New
                </Button>
                <Button
                  primary
                  icon={<SVGIcon name="Save" />}
                  onClick={onSave}
                  loading={saveLoading}
                  disabled={!selectedList.length}
                >
                  <FormattedMessage id="common.save" />
                </Button>
              </ButtonGroup>
            }
            // variant="secondary"
          >
            <AssociateTasks
              isRunbookAction
              hideSelectionSheetDoneBtn
              updateTaskList={updateTaskList}
              isRadio={props.type !== 'action' && !props.isAutoAction}
              setAllTasks={setAllTasks}
            />
          </Page>
        )}
      </Modal>
      {createTaskActive && (
        <CustomModal
          medium
          large={createTaskActive}
          open={createTaskActive}
          onClose={() => !taskTemplate?.taskTemplateId && handleNodeDelete()}
          showCloseButton={false}
          zIndex={517}
          noScroll
        >
          <TaskFromRevamp
            meta={{
              title: taskTemplate?.taskTemplateId
                ? getTranslatedText(
                    intl,
                    'admin.runbooks.templateactions.associatetask'
                  )
                : getTranslatedText(intl, 'admin.runbooks.tasks.newTask')
            }}
            toggleSheetActive={() => {
              closeBothModal();
            }}
            type={taskTemplate?.taskTemplateId ? 'update' : 'create'}
            isTemplate
            hideDelete={taskTemplate?.taskTemplateId ? false : true}
            data={taskTemplate}
            addOrUpdateTechGroup={addorUpdateTask}
            readOnly={taskTemplate?.taskTemplateId}
            isRunbookTemplate
            isAutoAction={props.isAutoAction}
            handleNodeDelete={handleNodeDelete}
            setSaveAsTemplate={setSaveAsTemplate}
            saveAsTemplate={saveAsTemplate}
            hideSections={taskTemplate?.taskTemplateId ? [] : ['status']}
          />
        </CustomModal>
      )}
    </>
  );
}

export default withErrorBoundary(injectIntl(AssociateTaskModal));
